import { render, staticRenderFns } from "./BillingForm.vue?vue&type=template&id=312b2b62&scoped=true&"
import script from "./BillingForm.vue?vue&type=script&lang=js&"
export * from "./BillingForm.vue?vue&type=script&lang=js&"
import style0 from "./BillingForm.vue?vue&type=style&index=0&id=312b2b62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312b2b62",
  null
  
)

export default component.exports